/**
 * PauseOverlay — dim+blur overlay shown between SUPERT cycles with the
 * 5→4→3→2→1 countdown. Driven by `phase === "paused"` and `pauseCountdown`.
 */
import { motion, AnimatePresence } from "framer-motion";

export function PauseOverlay({ visible, pauseCountdown }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 bg-slate-900/55 backdrop-blur-[2px] z-40 grid place-items-center"
          data-testid="pause-overlay"
        >
          <motion.div
            key={pauseCountdown}
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 1.6, opacity: 0 }}
            transition={{ type: "spring", stiffness: 220, damping: 18 }}
            className="text-center"
          >
            <div
              className="font-[Fredoka] font-extrabold italic text-amber-400 leading-none"
              style={{
                fontSize: "clamp(96px, 16vw, 200px)",
                textShadow: "4px 4px 0 rgba(0,0,0,0.4)",
                WebkitTextStroke: "3px #1f2937",
              }}
            >
              {pauseCountdown ?? ""}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default PauseOverlay;
